export default {
  'ledger.caller.canvas-prompt-optimize': 'Prompt Optimization',
  'ledger.title': 'Spending',
  'ledger.time': 'Time',
  'ledger.user': 'User',
  'ledger.caller': 'Task',
  'ledger.refId': 'Task ID',
  'ledger.amount': 'Spent',
  'ledger.balance': 'Balance',
  'ledger.empty': 'No spending records',
  'ledger.filterCaller': 'Task type',
  'ledger.filterDate': 'Date range',
  'ledger.filterUser': 'User search',
  'ledger.reset': 'Reset',
  'ledger.total': '{n} entries',

  'ledger.topup.title': 'Top-up records',
  'ledger.topup.orderNo': 'Order',
  'ledger.topup.amount': 'Amount',
  'ledger.topup.manual': 'Manual',
  'ledger.topup.credits': 'Credits',
  'ledger.topup.status': 'Status',
  'ledger.topup.paidAt': 'Paid at',
  'ledger.topup.empty': 'No top-up records',
  'ledger.topup.status.pending': 'Pending',
  'ledger.topup.status.paid': 'Paid',
  'ledger.topup.status.refunded': 'Refunded',
  'ledger.topup.status.failed': 'Failed',
  'ledger.topup.status.expired': 'Expired',
  'ledger.topup.source.custom': 'Custom',
  'ledger.topup.source.pack': 'Pack',

  'ledger.caller.canvas-image': 'Canvas Image',
  'ledger.caller.canvas_image': 'Canvas Image',
  'ledger.caller.canvas_image_freegen': 'Canvas Image',
  'ledger.caller.canvas_image_relight': 'Canvas Relight',
  'ledger.caller.canvas_image_multi_view': 'Canvas Multi-View',
  'ledger.caller.canvas_image_inpaint': 'Canvas Inpaint',
  'ledger.caller.canvas_image_outpaint': 'Canvas Outpaint',
  'ledger.caller.canvas_image_matting': 'Canvas Matting',
  'ledger.caller.canvas_image_hd': 'Canvas HD',
  'ledger.caller.canvas_image_panorama': 'Canvas Panorama',
  'ledger.caller.canvas_image_sheet': 'Sheet Grid',
  'ledger.caller.canvas_image_sheet_shot_grid': 'Sheet · Shot Grid',
  'ledger.caller.canvas_image_sheet_expression': 'Sheet · Expression Grid',
  'ledger.caller.canvas_image_sheet_action_pose': 'Sheet · Action Pose',
  'ledger.caller.canvas_image_sheet_outfit': 'Sheet · Outfit Variants',
  'ledger.caller.canvas_image_sheet_lighting': 'Sheet · Lighting',
  'ledger.caller.canvas_image_sheet_hand_detail': 'Sheet · Hand Detail',
  'ledger.caller.canvas-video': 'Canvas Video',
  'ledger.caller.canvas_video': 'Canvas Video',
  'ledger.caller.canvas_video_freegen': 'Canvas Video',
  'ledger.caller.canvas-audio': 'Canvas Audio',
  'ledger.caller.canvas_audio': 'Canvas Audio',
  'ledger.caller.canvas_audio_freegen': 'Canvas Audio',
  'ledger.caller.character_canonical': 'Character Canonical',
  'ledger.caller.character_shot': 'Character Shot',
  'ledger.caller.character_sheet': 'Character Sheet',
  'ledger.caller.scene_canonical': 'Scene Canonical',
  'ledger.caller.scene_sheet': 'Scene Sheet',
  'ledger.caller.scene_sheet_kind': 'Scene Sheet',
  'ledger.caller.scene_extra_view': 'Scene Extra View',
  'ledger.caller.scene_panorama': 'Scene Panorama',
  'ledger.caller.project_cover': 'Project Cover',
  'ledger.caller.storyboard_frame': 'Storyboard Frame',
  'ledger.caller.storyboard_video': 'Storyboard Video',
  'ledger.caller.storyboard_audio': 'Storyboard Audio',
  'ledger.caller.project-parse': 'Project Parse',
  'ledger.caller.parse-detect-marker': 'Episode Detection',
  'ledger.caller.parse-infer-meta': 'Project Meta Inference',
  'ledger.caller.parse-scene-boundaries': 'Scene Boundary Detection',
  'ledger.caller.parse-normalize-scene': 'Scene Normalization',
  'ledger.caller.gen-character-prompts': 'Character Prompts',
  'ledger.caller.video-prompt': 'Video Prompt',
  'ledger.caller.agent-chat': 'Agent Chat',
  'ledger.caller.learn-parse-dsl': 'Parse DSL Learning',
  'ledger.caller.extract-characters': 'Extract Characters',
  'ledger.caller.extract-scenes': 'Extract Scenes',
  'ledger.caller.enrich-project': 'Enrich Project',
  'ledger.caller.character-prompts': 'Character Prompts',
  'ledger.caller.character-sheet-cells': 'Character Sheet Cells',
  'ledger.caller.scene-sheet-cells': 'Scene Sheet Cells',
  'ledger.caller.storyboard': 'Storyboard',
  'ledger.caller.storyboard-gen': 'Storyboard',
  'ledger.caller.storyboard-shot-regenerate': 'Shot Regenerate',
  'ledger.caller.storyboard-frame-prompt': 'Storyboard Frame Prompt',
  'ledger.caller.storyboard-video-prompt': 'Storyboard Video Prompt',
  'ledger.caller.reverse-prompt-image': 'Image Reverse Prompt',
  'ledger.caller.reverse-prompt-video': 'Video Reverse Prompt',
  'ledger.caller.canvas-text-rewrite': 'Text Rewrite',
  'ledger.caller.novel-adapt': 'Novel Adaptation',
  'ledger.caller.oral-generate': 'Oral Script',
  'ledger.caller.canonicalize-scenes': 'Scene Dedup',
  'ledger.caller.skill-compile': 'Skill Compile',
  'ledger.caller.credit-quote': 'Credit Quote',
  'ledger.caller.admin-test': 'Admin Test',
  'ledger.caller.agent-im': 'Agent IM',
};
